export type RuntimeEnvironment = 'production' | 'staging' | 'local';

const trim = (value?: string) => (typeof value === 'string' ? value.trim().toLowerCase() : undefined);

const isProductionValue = (value?: string) => value === 'production' || value === 'prod';

const isStagingValue = (value?: string) =>
    value === 'staging' || value === 'preview' || value === 'development' || value === 'dev';

export const getRuntimeEnvironment = (): RuntimeEnvironment => {
    const vercelEnv = trim(process.env.VERCEL_ENV);
    const appEnv = trim(process.env.NEXT_PUBLIC_APP_ENV);
    const mobileEnv = trim(process.env.MOBILE_ENV);

    if (isProductionValue(vercelEnv) || isProductionValue(appEnv) || isProductionValue(mobileEnv)) {
        return 'production';
    }

    if (isStagingValue(vercelEnv) || isStagingValue(appEnv) || isStagingValue(mobileEnv)) {
        return 'staging';
    }

    return 'local';
};

export const isProductionRuntime = () => getRuntimeEnvironment() === 'production';
